<template>
  <div
    :class="[
      ns.b(),
      ns.is('selected', selected),
      ns.is('overdue', task.status === 'overdue'),
    ]"
    @click="emit('select', task.id)"
  >
    <div :class="ns.e('header')">
      <z-tag :type="priorityTag.type" size="small" effect="plain">
        {{ priorityTag.label }}
      </z-tag>
      <z-tag :type="statusTag.type" size="small">
        {{ statusTag.label }}
      </z-tag>
      <span :class="ns.e('title')">{{ task.title }}</span>
    </div>
    <p v-if="task.description" :class="ns.e('desc')">
      {{ task.description }}
    </p>
    <div :class="ns.e('meta')">
      <span>{{ task.module }} · {{ task.assignee }}</span>
      <span>{{ relativeTime }}</span>
    </div>
    <div v-if="showActions" :class="ns.e('actions')" @click.stop>
      <z-button
        v-if="task.status === 'pending' || task.status === 'overdue'"
        type="primary"
        link
        size="small"
        @click="emit('start', task.id)"
      >
        处理
      </z-button>
      <z-button
        v-if="task.status === 'processing'"
        type="success"
        link
        size="small"
        @click="emit('complete', task.id)"
      >
        完成
      </z-button>
      <z-button
        v-if="task.bizTab"
        link
        size="small"
        @click="emit('open', task)"
      >
        打开业务
      </z-button>
      <z-button
        v-if="task.status !== 'done' && task.status !== 'cancelled'"
        link
        size="small"
        @click="emit('ignore', task.id)"
      >
        忽略
      </z-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import ZButton from '@zoryn/components/button'
import ZTag from '@zoryn/components/tag'
import { PRIORITY_TAG_MAP, STATUS_TAG_MAP, type TaskRecord } from '../types'

const props = withDefaults(
  defineProps<{
    task: TaskRecord
    selected?: boolean
    showActions?: boolean
  }>(),
  {
    selected: false,
    showActions: true,
  }
)

const emit = defineEmits<{
  select: [id: string]
  start: [id: string]
  complete: [id: string]
  ignore: [id: string]
  open: [task: TaskRecord]
}>()

const ns = useNamespace('task-center-item')

const statusTag = computed(() => STATUS_TAG_MAP[props.task.status])
const priorityTag = computed(() => PRIORITY_TAG_MAP[props.task.priority])

const relativeTime = computed(() => {
  const diffMs = Date.now() - new Date(props.task.createTime).getTime()
  const hours = Math.floor(diffMs / (1000 * 60 * 60))
  if (hours < 1) return '刚刚'
  if (hours < 24) return `${hours} 小时前`
  const days = Math.floor(hours / 24)
  return `${days} 天前`
})
</script>
